<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col cols="3" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('rm_outcoming_movements.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-col cols="3" class="py-0" justify="center" align="center">
                    <v-autocomplete v-model="year" class="py-0" :label="$t('no_annex.year')" :items="years"></v-autocomplete>
                </v-col>
                <v-col cols="6" align="end" class="py-0">
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="showExport = true">
                        {{ $t('rm_outcoming_movements.export') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <v-data-table class="px-0 my-2"
                                :headers="headers"
                                :items="props.items"
                                :search="props.search"
                                calculate-widths
                                item-key="id"
                                :items-per-page="items_per_page"
                                hide-default-footer
                            >
                                <template v-slot:footer>
                                    <v-row>
                                        <v-col cols="7"></v-col>
                                        <v-col cols="1" align="end" justify="center">
                                            <v-autocomplete class="py-0 px-0" :label="$t('cm_outcoming_movements.items_per_page')" v-model="items_per_page" :items="items_options"></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4" align="right" justify="right" class="px-0">
                                            <v-pagination v-model="page" color="blue_accent" :length="pages" @input="next" justify="right" align="right"></v-pagination>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="showExport" persistent max-width="90%" style="width: 500px !important;">
                <v-card style="width:500px !important">
                    <v-card-title class="justify-center mt-4">
                        <v-row align="center" justify="center" class="my-2">
                            <label style="font-size: 16px; font-weight: bold;" class="blue_accent--text text-uppercase">{{$t('rm_outcoming_movements.export_data')}}</label>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-0 my-0 text-center">
                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu2" :model="report.initial_date" :label="$t('rm_outcoming_movements.initial_date')" @model="updateDate($event)" :rules_required="rules_required"></datepicker>
                            </v-col>

                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu3" :model="report.final_date" :label="$t('rm_outcoming_movements.final_date')" @model="updateDateFinal($event)" :rules_required="rules_required"></datepicker>
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="showExport = false">{{ $t('rm_outcoming_movements.cancel') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="exportData">
                                {{ $t('rm_outcoming_movements.export') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('rm_outcoming_movements.id'), align: "center", value: 'id', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.sku'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.umc'), align: "center", value: 'umc', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.dollars'), align: "center", value: 'dollars', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.departure_date'), align: "center", value: 'departure_date', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.id_customer'), align: "center", value: 'id_customer', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.sale_order'), align: "center", value: 'sale_order', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.number'), align: "center", value: 'number', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.key'), align: "center", value: 'key', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.destination_country'), align: "center", value: 'destination_country', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.merchandise_data'), align: "center", value: 'merchandise_data', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.guide'), align: "center", value: 'guide', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.commercial_invoice'), align: "center", value: 'commercial_invoice', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.electronic_notice'), align: "center", value: 'electronic_invoice', class: 'text-uppercase' },
                { text: this.$t('rm_outcoming_movements.date'), align: "center", value: 'date', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            report:{
                initial_date: '',
                final_date: ''
            },
            menu2: false,
            menu3: false,
            showExport: false,
            warehouse_id: this.$store.state.warehouseId,
            years: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
            year: "2024",
            page: 1,
            pages: 5,
            total_items: 500,
            items_per_page: 10,
            items_options: [10,25,50,100],
        }
    },
    mounted(){
        // this.index();
        this.$store.state.module = "headers.rm_outcoming_movements";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        updateDate(newDate){
            this.report.initial_date = newDate;
        },
        updateDateFinal(date){
            this.report.final_date = date;
        },
        index(){
            this.props.items = [];
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'customs/reports/outcome?warehouse=' + this.warehouse_id + '&startDate=' + this.year + '-01-01&endDate=' + this.year + '-12-31&perPage=' + this.items_per_page + '&page=' + this.page, {headers: {Authorization: lsToken}})
            .then((response) => {
                response.data.data.forEach(x => {
                    x = x.attributes;

                    var item = {
                        id: x.id,
                        umc: x.umc,
                        dollars: x.valueInDollars,
                        receipt_date: x.arrivalDate,
                        id_customer: x.clientId,
                        number: x.customsNumber,
                        key: x.cvedoc,
                        departure_date: x.arrivalDate,
                        destination_country: x.sourceCountry,
                        rate: "",
                        commercial_invoice: x.invoiceNumber,
                        electronic_notice: x.noticeNumber,
                        sale_order: x.purchaseOrder,
                        date: x.createdAt,
                        merchandise_data: x.description,
                        guide: "",
                    };

                    x.detailOrders.forEach( y => {
                        y = y.attributes;
                        item.sku = y.product.sku;
                        item.quantity = y.real;
                        this.props.items.push(item);
                    })
                });
                this.pages = response.data.meta.tota_pages;
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        exportData(){

        },
        next(page) {
            this.page = page;
            this.index();
        },
    },
    watch:{
        'year': function (){
            this.index();
        },
        'items_per_page': function(){
            this.index();
        }
    }
}
</script>

<style>
</style>